'use client';
import { useEffect } from 'react';
import { isObject } from '@s7/utils';

function useWindowEvent(type, listener, options) {
    const disabled = isObject(options) && options.disabled;
    useEffect(()=>{
        if (disabled) {
            return;
        }
        window.addEventListener(type, listener, options);
        return ()=>window.removeEventListener(type, listener, options);
    }, [
        type,
        listener,
        options
    ]);
}

export { useWindowEvent };
//# sourceMappingURL=useWindowEvent.js.map
